import { option } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { get, isEqual } from 'lodash/fp';
import { createSelector } from 'reselect';

import { PricingMode } from '@mews/enums';

import { getEnterprise, getEnterprisePricing } from './typedSelectors';

export const hasEnterpriseNetPricing = createSelector(getEnterprisePricing, isEqual(PricingMode.Net));

export const getEnterpriseDefaultCurrencyCode = flow(getEnterprise, get('defaultCurrencyCode'));

export const getEnterpriseName = flow(getEnterprise, get('name'));

export const getEnterpriseDefaultLanguageCode = flow(getEnterprise, get('defaultLanguageCode'));

export const getEnterpriseConfigurationId = flow(getEnterprise, get('configurationId'));

const getEnterpriseAddressOption = flow(
    getEnterprise,
    option.fromNullable,
    option.map((enterprise) => enterprise.address)
);

export const getEnterpriseAddressCountryCodeOption = flow(
    getEnterpriseAddressOption,
    option.flatMap((address) => option.fromNullable(address.countryCode))
);

export const getEnterpriseIsFxMulticurrencyServiceEnabled = flow(getEnterprise, get('isFxMultiCurrencyServiceEnabled'));
